<app-info-wrapper>
  <h1 info-page-header>
    {{ title | translate }}
  </h1>

  <div [formGroup]="submitForm" info-page-body>
    @if (description) {
      <p [innerHTML]="description | translate | unescape"></p>
    }
    <!-- TODO: Support of passwort fields with icons on the right that uncover the string -->
    @for (field of inputFields; track field) {
      <div class="input-field">
        @if (field.label) {
          <label
            class="input-label"
            [ngClass]="field.labelClass"
            [for]="field.input.id"
          >
            {{ field.label | translate }}
            @if (field.iconLabel) {
              <span class="input-label__icon">
                <i class="fas" [ngClass]="'fa-' + field.iconType"></i>
              </span>
            }
          </label>
        }
        <div class="input__icon-wrapper">
          <input
            [formControlName]="field.input.name"
            [type]="field.input.type ? field.input.type : 'text'"
            [placeholder]="field.input.placeholder | translate"
            class="input-text"
            [attr.required]="field.input.required"
          />
          @if (field.inputIcon && field.inputIcon.icon) {
            <span class="input__icon">
              <i [class]="field.inputIcon.icon" aria-hidden="true"></i>
            </span>
          }
        </div>
        <app-input-error
          [element]="submitForm.get(field.input.name)"
          [type]="field.input.name"
        ></app-input-error>
      </div>
    }
    @if (isLogin) {
      <div class="recaptcha-input">
        <span class="msg-error error"></span>
        <re-captcha
          id="recaptcha"
          class="g-recaptcha"
          formControlName="captcha"
          (resolved)="resolved($event)"
          [siteKey]="siteKey"
          required
        ></re-captcha>
      </div>
    }
    <ng-template #inputInsert></ng-template>
  </div>
  @if (footerContent) {
    <div info-page-footer>
      @if (footerContent.description) {
        <p [innerHTML]="footerContent.description | translate"></p>
      }

      @if (footerContent.links) {
        <div>
          @for (link of footerContent.links; track link; let i = $index) {
            <div>
              @if (i > 0) {
                <span class="link-divider">&nbsp;/&nbsp;</span>
              }
              @if (!footerContent.links.preparedLink?.urlObject) {
                <a
                  class="info-page__link"
                  [routerLink]="[link.preparedLink.url] | localize"
                  >{{ link.text | translate }}</a
                >
              }
              @if (link.preparedLink.urlObject) {
                <a class="info-page__link" [href]="link.preparedLink.url">{{
                  link.text | translate
                }}</a>
              }
            </div>
          }
        </div>
      }
      @if (isLogin) {
        <div class="info-page__register">
          <a
            class="info-page__link info-page__link--register"
            (click)="popupService.showRegisterModal()"
          >
            {{ "texts.InfoPageComponent_student_register" | translate }} </a
          >&nbsp;/&nbsp;
          <a
            class="info-page__link info-page__link--register"
            [routerLink]="['/TutorRegistration_TeacherInfo'] | localize"
          >
            {{ "texts.InfoPageComponent_tutor_register" | translate }}
          </a>
        </div>
      }
    </div>
  }
</app-info-wrapper>
